import { useState, useRef, useCallback } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const BeforeAfterSlider = ({ before, after, alt = "", testId = "before-after-slider" }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos(Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100)));
  }, []);

  return (
    <div ref={ref} data-testid={testId}
      className="relative w-full h-full select-none overflow-hidden cursor-ew-resize touch-pan-y"
      onPointerDown={(e) => { dragging.current = true; e.currentTarget.setPointerCapture(e.pointerId); move(e.clientX); }}
      onPointerMove={(e) => dragging.current && move(e.clientX)}
      onPointerUp={() => { dragging.current = false; }}
    >
      <img src={after} alt={`${alt} — après`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img src={before} alt={`${alt} — avant`} className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} draggable={false} />
      <span className="absolute top-3 left-3 bg-[#1A1A1A]/80 text-white text-[10px] tracking-[0.2em] uppercase px-2 py-1">Avant</span>
      <span className="absolute top-3 right-3 bg-[#D4A853] text-[#1A1A1A] text-[10px] tracking-[0.2em] uppercase px-2 py-1">Après</span>
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,0.4)] pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white shadow-lg flex items-center justify-center text-[#1A1A1A]">
          <CaretLeft size={12} weight="bold" /><CaretRight size={12} weight="bold" />
        </div>
      </div>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Comparer avant et après" className="absolute inset-0 w-full h-full opacity-0 pointer-events-none"
        data-testid={`${testId}-range`} />
    </div>
  );
};

export default BeforeAfterSlider;
